import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '@rsos/components/capstone/base/Dropdown';
import AgencyShareChatDropdown from '../AgencyShareChatDropdown';
import ASCPopover from './ASCPopover';

/**
 * Sub-component of <AgencyShareChatButton />.
 * Renders the agency share/chat drop down wrapper.
 * @param {Array} peerAgencies - List of paired peer agencies.
 */
const ASCDropdown = ({ peerAgencies }) => {
  return (
    <Dropdown triggerElement={ASCPopover} triggerOnClose>
      {onShare => (
        <AgencyShareChatDropdown
          data-name="agency-share-chat-dropdown"
          onShare={onShare}
          peerAgencies={peerAgencies}
        />
      )}
    </Dropdown>
  );
};

AgencyShareChatDropdown.propTypes = {
  peerAgencies: PropTypes.arrayOf(
    PropTypes.shape({
      account_id: PropTypes.string,
      display_name: PropTypes.string,
    }),
  ),
};

export default ASCDropdown;
